import { render, staticRenderFns } from "./Edgecaster_Max.vue?vue&type=template&id=3c6d7bf2"
import script from "./Edgecaster_Max.vue?vue&type=script&lang=js"
export * from "./Edgecaster_Max.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports